import type { TFunction } from 'i18next';
import sAttr from '../../_json/s_attr';
import type { Facets, Filter } from '../../_types/Car';
import type { Translations } from '../../locales/translations';
import checkUndefinedNullOrEmpty from '../tools/checkUndefinedNullOrEmpty';
import checkUndefinedOrNull from '../tools/checkUndefinedOrNull';
import uniqueArray from '../tools/uniqueArray';

export default function getSearchDesc(translate: TFunction, facets?: Facets, filter?: Filter) {
    const ret = [];

    if (!checkUndefinedOrNull(filter?.hersteller0) && filter?.hersteller0 >= 0) {
        const hs = facets?.herstellerAll?.find((f) => f?.i === filter?.hersteller0)?.t;
        ret.push(`${translate('common:filter.hersteller')}: ${hs}`);
    }

    if (!checkUndefinedOrNull(filter?.modell0) && filter?.modell0 >= 0) {
        const md = facets?.modellAll?.find((f) => f?.i === filter?.modell0)?.t;
        ret.push(`${translate('common:filter.modell')}: ${md}`);
    }

    if (!checkUndefinedOrNull(filter?.MotorG) && filter?.MotorG >= 0) {
        const motor = facets?.MotorGAll?.find((f) => f?.i === filter?.MotorG)?.t;
        ret.push(`${translate('common:filter.motor')}: ${motor}`);
    } else if (!checkUndefinedNullOrEmpty(filter?.motoren)) {
        const motorArr = [];
        filter?.motoren.map(function (t) {
            const motorRaw = facets?.MotorGAll?.find((f) => f?.i === t)?.t;
            motorArr.push(motorRaw);
        });
        ret.push(`${translate('common:filter.motor')}: ${motorArr.join(', ')}`);
    }

    if (!checkUndefinedOrNull(filter?.Getriebe) && filter?.Getriebe >= 0) {
        const getr = facets?.getriebeAll?.find((f) => f?.i === filter?.Getriebe)?.t;
        ret.push(`${translate('common:filter.getriebe')}: ${getr}`);
    }

    if (!checkUndefinedNullOrEmpty(filter?.akttypList)) {
        const typArr = [];
        let typLast = '';
        const newFilterArray = uniqueArray(filter?.akttypList?.map((val) => (val > 0 && val !== 1 ? 2 : val)))?.sort();
        newFilterArray?.map(function (t, i) {
            const typ: string = translate(`common:car.types.plural.${t?.toString() as keyof Translations['car']['types']['plural']}`);
            if (i !== newFilterArray?.length - 1) {
                typArr.push(typ.replace('wagen', '-'));
            } else {
                typLast = typ;
            }
        });
        if (typArr.length > 0) {
            ret.push([typArr.join(', '), typLast].join(` ${translate('common:common.and')} `));
        } else {
            ret.push(typLast);
        }
    } else {
        ret.push(`${translate('common:filter.typ')}: ${translate(facets?.firmen?.[0]?.i !== 54630 ? 'common:carSearch.heading' : 'common:carSearch.heading2')}`);
    }

    if (!checkUndefinedOrNull(filter?.tags)) {
        const tags = facets?.tagsAll?.find((f) => f?.i === filter?.tags)?.t;
        ret.push(`${translate('common:filter.tags')}: ${tags}`);
    }

    if (!checkUndefinedNullOrEmpty(filter?.Rate)) {
        const pr = filter?.Rate[0] + '€ - ' + filter?.Rate[1] + '€';
        ret.push(`${translate('common:filter.rate')}: ${pr}`);
    } else if (!checkUndefinedNullOrEmpty(filter?.Preis)) {
        const pr = filter?.Preis[0] + '€ - ' + filter?.Preis[1] + '€';
        ret.push(`${translate('common:filter.preis')}: ${pr}`);
    }

    if (!checkUndefinedNullOrEmpty(filter?.EZ)) {
        const ez = filter?.EZ[0] + ' - ' + filter?.EZ[1];
        ret.push(`${translate('common:filter.ez')}: ${ez}`);
    }

    if (!checkUndefinedNullOrEmpty(filter?.ia)) {
        const aus = [];
        const sAttrTranslate = sAttr(translate);
        const sAttrAreas: Record<'innen' | 'aussen' | 'assistenz' | 'sonstiges', string[]> = Object.keys(sAttrTranslate)?.reduce(
            (p, c) => ({
                ...p,
                [c]: sAttrTranslate?.[c]?.map((a) => a?.i),
            }),
            { innen: [], aussen: [], assistenz: [], sonstiges: [] }
        );
        filter?.ia.map(function (a) {
            let map = [];
            if (sAttrAreas?.innen?.includes(a)) {
                map = sAttrTranslate.innen;
            } else if (sAttrAreas?.aussen?.includes(a)) {
                map = sAttrTranslate.aussen;
            } else if (sAttrAreas?.assistenz?.includes(a)) {
                map = sAttrTranslate.assistenz;
            } else if (sAttrAreas?.sonstiges?.includes(a)) {
                map = sAttrTranslate.sonstiges;
            }
            aus.push(map?.find((m) => m?.i === a)?.t);
        });
        ret.push(`${translate('common:filter.aus')}: ${aus.join(', ')}`);
    }

    if (!checkUndefinedOrNull(filter?.moreCars) && filter?.moreCars > 1) {
        ret.push(`- ${translate('common:carSearch.page')} ${filter?.moreCars}`);
    }
    return ret.join(' | ');
}
